import request from "@/utils/request"



// 登录
export const login = (user) => {

    return request({
      method: "POST",
      data:user,
      url: "/handle/index/login",
    });
  }

  // 注册
export const register = (user) => {

  return request({
    method: "POST",
    data:user,
    url: "/handle/index/register",
  });
}
  // 验证码
  export const loginsend = (user) => {

    return request({
      method: "POST",
      data:user,
      url: "/handle/index/loginsend",
    });
  }
    // jiaoyan
export const jiaoyan = (user) => {

  return request({
    method: "POST",
    data:user,
    url: "/handle/index/jiaoyan",
  });
}
// 手机登录 
export const loginbymobile = (user) => {

  return request({
    method: "POST",
    data:user,
    url: "/handle/index/loginbymobile",
  });
}
// 
export const savepwd = (user) => {

  return request({
    method: "POST",
    data:user,
    url: "/handle/index/savepwd",
  });
}


// WEBPACK FOOTER //
// ./src/api/system/login.js